import { Routes, Route, Navigate } from 'react-router-dom';
import { ComplianceLandingPage } from './compliance-landing-page';
import { ComplianceDashboardPage } from './dashboard-page';
import { AlertsPage } from './alerts-page';
import { PersonnelPage } from './personnel-page';
import { PersonnelNewPage } from './personnel-new-page';
import { InsurancePage } from './insurance-page';
import { InsuranceNewPage } from './insurance-new-page';
import { LegalEntityPage } from './legal-entity-page';
import { QuarterlyStatisticsListPage } from './quarterly-statistics-list-page';
import { CreateQuarterlyStatisticsPage } from './create-quarterly-statistics-page';
import { QuarterlyStatisticsDetailPage } from './quarterly-statistics-detail-page';
import { SafetyKPIDashboardPage } from './safety-kpi-dashboard-page';
import {
  ComplianceIncidentsPage,
  CreateComplianceIncidentPage,
  ComplianceIncidentDetailPage,
  InvestigatePage,
} from './incidents';
import { AuditPrepPage } from './audit-prep-page';
import { AuditPrepNewPage } from './audit-prep-new-page';
import { AuditPrepDetailPage } from './audit-prep-detail-page';
import { ReviewsPage } from './reviews-page';
import { ReviewsNewPage } from './reviews-new-page';
import { ReviewsDetailPage } from './reviews-detail-page';
import { ConsultantPage } from './consultant-page';
import { ActionsPage, ActionDetailPage } from './actions';
import { ComplianceProfilePage } from './compliance-profile-page';
import { ClausesLandingPage, SectionClausesPage, ClauseDetailPage } from './clauses';
import { SetupWizardPage } from './setup-wizard-page';
import { GeneratedDocumentsPage } from './generated-documents-page';
import { ProposedEvidencePage } from './proposed-evidence-page';

export function ComplyPage() {
  return (
    <Routes>
      {/* Landing & Dashboard */}
      <Route index element={<ComplianceLandingPage />} />
      <Route path="dashboard" element={<ComplianceDashboardPage />} />
      <Route path="alerts" element={<AlertsPage />} />

      {/* Clause-centric navigation (C08 — FM-312 Sections 2–8) */}
      <Route path="clauses" element={<ClausesLandingPage />} />
      <Route path="clauses/section/:sectionNumber" element={<SectionClausesPage />} />
      <Route path="clauses/:id" element={<ClauseDetailPage />} />

      {/* Nominated Personnel, Insurance, Legal Entity (QP-300 Clauses 2.4/2.5) */}
      <Route path="personnel" element={<PersonnelPage />} />
      <Route path="personnel/new" element={<PersonnelNewPage />} />
      <Route path="insurance" element={<InsurancePage />} />
      <Route path="insurance/new" element={<InsuranceNewPage />} />
      <Route path="legal" element={<LegalEntityPage />} />

      {/* Quarterly Statistics, Safety KPIs, Incidents */}
      <Route path="statistics" element={<QuarterlyStatisticsListPage />} />
      <Route path="statistics/new" element={<CreateQuarterlyStatisticsPage />} />
      <Route path="statistics/:id" element={<QuarterlyStatisticsDetailPage />} />
      <Route path="kpis" element={<SafetyKPIDashboardPage />} />
      <Route path="incidents" element={<ComplianceIncidentsPage />} />
      <Route path="incidents/new" element={<CreateComplianceIncidentPage />} />
      <Route path="incidents/:id" element={<ComplianceIncidentDetailPage />} />
      <Route path="incidents/:id/investigate" element={<InvestigatePage />} />

      {/* Audit Preparation (FM-333 / FM-312) */}
      <Route path="audit-prep" element={<AuditPrepPage />} />
      <Route path="audit-prep/new" element={<AuditPrepNewPage />} />
      <Route path="audit-prep/:id" element={<AuditPrepDetailPage />} />

      {/* Management Reviews (QP-300 Clause 8.2) */}
      <Route path="reviews" element={<ReviewsPage />} />
      <Route path="reviews/new" element={<ReviewsNewPage />} />
      <Route path="reviews/:id" element={<ReviewsDetailPage />} />

      {/* CAPA Register (C02) */}
      <Route path="actions" element={<ActionsPage />} />
      <Route path="actions/:id" element={<ActionDetailPage />} />

      {/* Proposed Evidence Inbox (SQ-2) */}
      <Route path="proposed-evidence" element={<ProposedEvidencePage />} />

      {/* Setup Wizard & Generated Documents */}
      <Route path="setup-wizard" element={<SetupWizardPage />} />
      <Route path="generated-documents" element={<GeneratedDocumentsPage />} />

      {/* Compliance Profile Settings */}
      <Route path="settings/profile" element={<ComplianceProfilePage />} />

      {/* Consultant Portal (multi-org) */}
      <Route path="consultant" element={<ConsultantPage />} />

      <Route path="*" element={<Navigate to="/compliance" replace />} />
    </Routes>
  );
}
